'use strict';

var Fuse = require('fuse.js');
var Mark = require('mark.js');
var Utils = require('../utils/utils');

// Constructor
var SearchProfiles = function() {

  var self = this;

  self.config = {
    'search'        :  $('.search-profiles'),
    'grid'          :  $('.search-profiles__grid'),
    'gridItem'      :  $('.search-profiles__item'),
    'cardTemplate'  :  $('.profile-card__template'),
    'content'       :  $('.search-profiles__content'),
    'input'         :  $('.search-profiles__input')
  }

  var fuseOpts = {
    include: ['matches'],
    shouldSort: true,
    threshold: 0.2,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      'name',
      'birthdate',
      'bio.text'
    ]
  };
  var markOpts = {
    element: 'span'
  };

  self.findEls = function() {
    var _$grid = self.config.search.find(self.config.grid);
    var _$defaultItem = self.config.search.find(self.config.gridItem);
    var _$input = self.config.search.find(self.config.input);
    var content = JSON.parse(self.config.search.find(self.config.content).html());
    var cardTemplate = self.config.cardTemplate.html();

    self.initSearch(_$grid, _$defaultItem, _$input, content, cardTemplate);
  }

  self.initSearch = function(_$grid, _$defaultItem, _$input, content, cardTemplate) {

    var fuse = new Fuse(content, fuseOpts);

    _$input.on('keyup.dropdownSearch', new Utils().throttle(function() {
      var $this = $(this);
      var value = $this.val();
      var results = fuse.search(value);

      if (value === '') {
        self.removeResultItems(_$grid);
        self.showDefaultItems(_$defaultItem);
      } else {
        self.removeResultItems(_$grid);
        self.hideDefaultItems(_$defaultItem);
        self.showResults(_$grid, cardTemplate, results)
      }
    }, 300));
  }

  self.showResults = function(_$grid, cardTemplate, results) {

    var resultItem = _.template(cardTemplate);
    var appendItem = function(result) {
      _$grid.append(resultItem({item: result.item}));
    };
    var $currentResultItem = _$grid.find($('.is-profile-search-item'));

    results.forEach(function(result) {

      if (! $currentResultItem.length) {
        appendItem(result);
        self.highlightResultText(_$grid, result);
      }
    });
  }

  self.highlightResultText = function(_$grid, result) {
    var _$resultItem = _$grid.find($('.is-profile-search-item'));

    _$resultItem.each(function() {
      var $this = $(this);
      var nameText = $this.find('.profile-card__name').text();
      var birthdateText = $this.find('.profile-card__birthdate').text();
      var initHighlight = function(indices, text) {
        var highlight = text.substring(indices[0], indices[1] + 1);
        var markInstance = new Mark($this[0]);
        markInstance.mark(highlight, markOpts);
      };

      result.matches.forEach(function(match) {

        match.indices.forEach(function(indices) {

          if (match.key === 'name') {
            initHighlight(indices, nameText);
          }

          if (match.key === 'birthdate') {
            initHighlight(indices, birthdateText);
          }
        });
      });
    });
  }

  self.hideDefaultItems = function(_$defaultItem) {
    _$defaultItem.not('is-search-item').hide();
  }

  self.showDefaultItems = function(_$defaultItem) {
    _$defaultItem.not('is-search-item').show();
  }

  self.removeResultItems = function(_$grid) {
    var _$resultItem = _$grid.find($('.is-profile-search-item'));
    _$resultItem.remove();
  }

  self.init = function() {

    if (self.config.search.length) {
      self.findEls();
    }
  }
};

module.exports = SearchProfiles;
